import React from "react";
import "./fisherman-details.scss";
import makeStyles from "@material-ui/core/styles/makeStyles";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import { withRouter } from "react-router-dom";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import Paper from "@material-ui/core/Paper";
import { connect } from "react-redux";

const useStyles = makeStyles((theme) => ({
    table: {},
    paper: {
        padding: theme.spacing(2),
        textAlign: "center",
        color: theme.palette.text.secondary,
    },
}));

const FishermanDetails = ({ consignment }) => {
    const classes = useStyles();
    const createRows = (label, value) => ({ label, value });
    let rows = [];

    if (consignment) {
        rows.push(
            createRows(
                "Fisherman name:",
                consignment.retailerProduct.purchase.fishermanName
            )
        );
        rows.push(
            createRows(
                "Boat name:",
                consignment.retailerProduct.purchase.boatName
            )
        );
        rows.push(
            createRows(
                "Caught on:",
                consignment.retailerProduct.purchase.caughtOn
                    .toDate()
                    .toLocaleDateString()
            )
        );
        rows.push(
            createRows(
                "Location",
                `Lat: ${consignment.retailerProduct.purchase.pfzLocation.latitude}, Lon: ${consignment.retailerProduct.purchase.pfzLocation.longitude}`
            )
        );
    }

    return !consignment ? (
        ""
    ) : (
        <Container style={{ maxWidth: 650 }}>
            <Paper className={classes.paper}>
                <Typography variant={"h6"}>Fisherman details</Typography>
                <TableContainer>
                    <Table
                        className={classes.table}
                        size="small"
                        aria-label="a dense table"
                    >
                        <TableBody>
                            {rows.map((row) => (
                                <TableRow key={row.label}>
                                    <TableCell component="th" scope="row">
                                        {row.label}
                                    </TableCell>
                                    <TableCell align="right">
                                        {row.value}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        </Container>
    );
};
const mapStateToProps = ({common})=>({
    consignment: common.current
});
export default withRouter(connect(mapStateToProps)(FishermanDetails));
